module.exports = __webpack_public_path__ + "zespol_02.jpg?14bba24be4c5fe6498ddad76ecc36274";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zespol_02.jpg
// module id = 147
// module chunks = 0